export type ItsColumnDef = {
  id: string;
  label: string;
  type: "string" | "number";
  category?: string;
};

export const ITS_COLUMNS: ItsColumnDef[] = [
  // Identity & Family
  { id: "ITS_ID", label: "ITS ID", type: "string", category: "Identity & Family" },
  { id: "HOF_FM_TYPE", label: "HOF/FM Type", type: "string", category: "Identity & Family" },
  { id: "HOF_ID", label: "HOF ID", type: "string", category: "Identity & Family" },
  { id: "Family_ID", label: "Family ID", type: "string", category: "Identity & Family" },
  { id: "Father_ITS_ID", label: "Father ITS ID", type: "string", category: "Identity & Family" },
  { id: "Mother_ITS_ID", label: "Mother ITS ID", type: "string", category: "Identity & Family" },
  { id: "Spouse_ITS_ID", label: "Spouse ITS ID", type: "string", category: "Identity & Family" },
  { id: "TanzeemFile_No", label: "Tanzeem File No", type: "string", category: "Identity & Family" },
  { id: "Full_Name", label: "Full Name", type: "string", category: "Identity & Family" },
  {
    id: "Full_Name_Arabic",
    label: "Full Name (Arabic)",
    type: "string",
    category: "Identity & Family",
  },
  { id: "First_Prefix", label: "First Prefix", type: "string", category: "Identity & Family" },
  { id: "Prefix_Year", label: "Prefix Year", type: "string", category: "Identity & Family" },
  { id: "First_Name", label: "First Name", type: "string", category: "Identity & Family" },
  { id: "Father_Prefix", label: "Father Prefix", type: "string", category: "Identity & Family" },
  { id: "Father_Name", label: "Father Name", type: "string", category: "Identity & Family" },
  { id: "Father_Surname", label: "Father Surname", type: "string", category: "Identity & Family" },
  { id: "Husband_Prefix", label: "Husband Prefix", type: "string", category: "Identity & Family" },
  { id: "Husband_Name", label: "Husband Name", type: "string", category: "Identity & Family" },
  { id: "Surname", label: "Surname", type: "string", category: "Identity & Family" },

  // Demographics
  { id: "Age", label: "Age", type: "number", category: "Demographics" },
  { id: "Hijri_Age", label: "Hijri Age", type: "number", category: "Demographics" },
  { id: "Gender", label: "Gender", type: "string", category: "Demographics" },
  { id: "Misaq", label: "Misaq", type: "string", category: "Demographics" },
  { id: "Marital_Status", label: "Marital Status", type: "string", category: "Demographics" },
  { id: "Blood_Group", label: "Blood Group", type: "string", category: "Demographics" },
  { id: "Warakatul_Tarkhis", label: "Warakatul Tarkhis", type: "string", category: "Demographics" },
  { id: "Date_Of_Nikah", label: "Date of Nikah", type: "string", category: "Demographics" },
  {
    id: "Date_Of_Nikah_Hijri",
    label: "Date of Nikah (Hijri)",
    type: "string",
    category: "Demographics",
  },

  // Contact & Location
  { id: "Mobile", label: "Mobile", type: "string", category: "Contact & Location" },
  { id: "Email", label: "Email", type: "string", category: "Contact & Location" },
  { id: "Address", label: "Address", type: "string", category: "Contact & Location" },
  { id: "Building", label: "Building", type: "string", category: "Contact & Location" },
  { id: "Street", label: "Street", type: "string", category: "Contact & Location" },
  { id: "Area", label: "Area", type: "string", category: "Contact & Location" },
  { id: "State", label: "State", type: "string", category: "Contact & Location" },
  { id: "City", label: "City", type: "string", category: "Contact & Location" },
  { id: "Pincode", label: "Pincode", type: "string", category: "Contact & Location" },
  { id: "Sector", label: "Sector", type: "string", category: "Contact & Location" },
  { id: "Sub_Sector", label: "Sub Sector", type: "string", category: "Contact & Location" },
  { id: "Vatan", label: "Vatan", type: "string", category: "Contact & Location" },
  { id: "Nationality", label: "Nationality", type: "string", category: "Contact & Location" },
  { id: "Jamaat", label: "Jamaat", type: "string", category: "Contact & Location" },
  { id: "Jamiaat", label: "Jamiaat", type: "string", category: "Contact & Location" },

  // Occupation & Skills
  { id: "Title", label: "Title", type: "string", category: "Occupation & Skills" },
  { id: "Category", label: "Category", type: "string", category: "Occupation & Skills" },
  { id: "Idara", label: "Idara", type: "string", category: "Occupation & Skills" },
  { id: "Organisation", label: "Organisation", type: "string", category: "Occupation & Skills" },
  {
    id: "Organisation_CSV",
    label: "Organisation CSV",
    type: "string",
    category: "Occupation & Skills",
  },
  { id: "Qualification", label: "Qualification", type: "string", category: "Occupation & Skills" },
  { id: "Languages", label: "Languages", type: "string", category: "Occupation & Skills" },
  { id: "Hunars", label: "Hunars", type: "string", category: "Occupation & Skills" },
  { id: "Occupation", label: "Occupation", type: "string", category: "Occupation & Skills" },
  {
    id: "Sub_Occupation",
    label: "Sub Occupation",
    type: "string",
    category: "Occupation & Skills",
  },
  {
    id: "Sub_Occupation2",
    label: "Sub Occupation 2",
    type: "string",
    category: "Occupation & Skills",
  },

  // Religious & Ziyarat
  { id: "Quran_Sanad", label: "Quran Sanad", type: "string", category: "Religious & Ziyarat" },
  {
    id: "Qadambosi_Sharaf",
    label: "Qadambosi Sharaf",
    type: "string",
    category: "Religious & Ziyarat",
  },
  {
    id: "Raudat_Tahera_Ziyarat",
    label: "Raudat Tahera Ziyarat",
    type: "string",
    category: "Religious & Ziyarat",
  },
  {
    id: "Karbala_Ziyarat",
    label: "Karbala Ziyarat",
    type: "string",
    category: "Religious & Ziyarat",
  },
  {
    id: "Ashara_Mubaraka",
    label: "Ashara Mubaraka",
    type: "number",
    category: "Religious & Ziyarat",
  },

  // Administration & Verification
  { id: "Housing", label: "Housing", type: "string", category: "Administration" },
  { id: "Type_of_House", label: "Type of House", type: "string", category: "Administration" },
  { id: "Inactive_Status", label: "Inactive Status", type: "string", category: "Administration" },
  {
    id: "Data_Verifcation_Status",
    label: "Data Verification Status",
    type: "string",
    category: "Administration",
  },
  {
    id: "Data_Verification_Date",
    label: "Data Verification Date",
    type: "string",
    category: "Administration",
  },
  {
    id: "Photo_Verifcation_Status",
    label: "Photo Verification Status",
    type: "string",
    category: "Administration",
  },
  {
    id: "Photo_Verification_Date",
    label: "Photo Verification Date",
    type: "string",
    category: "Administration",
  },
  {
    id: "Last_Scanned_Event",
    label: "Last Scanned Event",
    type: "string",
    category: "Administration",
  },
  {
    id: "Last_Scanned_Place",
    label: "Last Scanned Place",
    type: "string",
    category: "Administration",
  },
  {
    id: "Sector_Incharge_ITSID",
    label: "Sector Incharge ITS ID",
    type: "string",
    category: "Administration",
  },
  {
    id: "Sector_Incharge_Name",
    label: "Sector Incharge Name",
    type: "string",
    category: "Administration",
  },
  {
    id: "Sector_Incharge_Female_ITSID",
    label: "Sector Incharge Female ITS ID",
    type: "string",
    category: "Administration",
  },
  {
    id: "Sector_Incharge_Female_Name",
    label: "Sector Incharge Female Name",
    type: "string",
    category: "Administration",
  },
  {
    id: "Sub_Sector_Incharge_ITSID",
    label: "Sub Sector Incharge ITS ID",
    type: "string",
    category: "Administration",
  },
  {
    id: "Sub_Sector_Incharge_Name",
    label: "Sub Sector Incharge Name",
    type: "string",
    category: "Administration",
  },
  {
    id: "Sub_Sector_Incharge_Female_ITSID",
    label: "Sub Sector Incharge Female ITS ID",
    type: "string",
    category: "Administration",
  },
  {
    id: "Sub_Sector_Incharge_Female_Name",
    label: "Sub Sector Incharge Female Name",
    type: "string",
    category: "Administration",
  },
];

export type OperatorDef = { id: string; label: string };

export const STRING_OPERATORS: OperatorDef[] = [
  { id: "equals", label: "Equals" },
  { id: "notEquals", label: "Not Equals" },
  { id: "contains", label: "Contains" },
  { id: "notContains", label: "Not Contains" },
  { id: "startsWith", label: "Starts With" },
  { id: "endsWith", label: "Ends With" },
  { id: "in", label: "In (multiple values)" },
  { id: "notIn", label: "Not In (multiple values)" },
  { id: "isEmpty", label: "Is Empty" },
  { id: "isNotEmpty", label: "Is Not Empty" },
];

export const NUMBER_OPERATORS: OperatorDef[] = [
  { id: "equals", label: "Equals" },
  { id: "notEquals", label: "Not Equals" },
  { id: "greaterThan", label: "Greater Than (>)" },
  { id: "greaterThanOrEqual", label: "Greater Than or Equal (>=)" },
  { id: "lessThan", label: "Less Than (<)" },
  { id: "lessThanOrEqual", label: "Less Than or Equal (<=)" },
  { id: "in", label: "In (multiple values)" },
  { id: "notIn", label: "Not In (multiple values)" },
  { id: "isEmpty", label: "Is Empty" },
  { id: "isNotEmpty", label: "Is Not Empty" },
];

export const getOperatorsForType = (type: ItsColumnDef["type"]): OperatorDef[] =>
  type === "number" ? NUMBER_OPERATORS : STRING_OPERATORS;

/** Niyaaz registration fields for Event RSVP broadcast filters (not ITS data). */
export const NIYAAZ_COLUMNS: ItsColumnDef[] = [
  { id: "markaz", label: "Markaz / Venue", type: "string", category: "Event Details" },
  { id: "namaazVenue", label: "Namaaz Venue", type: "string", category: "Event Details" },
  { id: "HOFId", label: "HOF ITS", type: "string", category: "HOF Details" },
  { id: "HOFName", label: "HOF Name", type: "string", category: "HOF Details" },
  { id: "HOFPhone", label: "HOF Phone", type: "string", category: "HOF Details" },
  { id: "formNo", label: "Form No", type: "string", category: "Event Details" },
  { id: "sendReminders", label: "Send Reminders", type: "string", category: "Preferences" },
  { id: "relayRequired", label: "Relay Required", type: "string", category: "Preferences" },
  { id: "pirsaRequired", label: "Pirsa Required", type: "string", category: "Preferences" },
  { id: "pirsaSelfPickup", label: "Pirsa Self Pickup", type: "string", category: "Preferences" },
  { id: "balance", label: "Balance", type: "number", category: "Financial" },
  { id: "paidAmount", label: "Paid Amount", type: "number", category: "Financial" },
  { id: "totalPayable", label: "Total Payable", type: "number", category: "Financial" },
  { id: "takhmeenAmount", label: "Takhmeen Amount", type: "number", category: "Financial" },
  { id: "chairs", label: "Chairs", type: "number", category: "Attendance" },
  { id: "mehmaanCount", label: "Mehmaan Count", type: "number", category: "Attendance" },
  { id: "gentsCount", label: "Gents Count", type: "number", category: "Attendance" },
  { id: "ladiesCount", label: "Ladies Count", type: "number", category: "Attendance" },
];

/** Mutawatteen household member fields for Miqaat RSVP broadcast filters. */
export const MUTTAVATTEEN_MEMBER_COLUMNS: ItsColumnDef[] = [
  { id: "name", label: "Name", type: "string", category: "Member Info" },
  { id: "itsNo", label: "ITS No", type: "string", category: "Member Info" },
  { id: "whatsappNo", label: "WhatsApp No", type: "string", category: "Member Info" },
  { id: "isHof", label: "Is HOF", type: "string", category: "Member Info" },
];

export type FilterRuleRow = {
  id: string;
  field: string;
  operator: string;
  value: string;
};

export type FilterGroupData = {
  id: string;
  logic: "AND" | "OR";
  rules: FilterRuleRow[];
  groups: FilterGroupData[];
};
